declare global {
  interface Window {
    mixpanel: any;
    attachEvent: any;
  }
}

class InspectletUtils {
  static init(inspectletId: number) {
    // @ts-ignore
    window.__insp = window.__insp || [];
    // @ts-ignore
    __insp.push(["wid", inspectletId]);
    (function() {
      function ldinsp() {
        // @ts-ignore
        if (typeof window.__inspld != "undefined") return;
        // @ts-ignore
        window.__inspld = 1;
        var insp = document.createElement("script");
        insp.type = "text/javascript";
        insp.async = true;
        insp.id = "inspsync";
        insp.src =
          ("https:" == document.location.protocol ? "https" : "http") +
          "://cdn.inspectlet.com/inspectlet.js";
        var x = document.getElementsByTagName("script")[0];
        // @ts-ignore
        x.parentNode.insertBefore(insp, x);
      }
      setTimeout(ldinsp, 500);
      // @ts-ignore
      document.readyState != "complete"
        ? window.attachEvent
          ? window.attachEvent("onload", ldinsp)
          : window.addEventListener("load", ldinsp, false)
        : ldinsp();
    })();
  }
}

export default InspectletUtils;
